// Two chalkboard variants — a classic black board and a classic green
// school board — so the existing light/dark toggle stays useful without
// breaking the hand-drawn chalk concept.

export const darkTheme = {
  bg: "#17191a",
  bgLight: "#212425",
  primary: "#f2c94c",
  secondary: "#ff9fb2",
  text_primary: "#f6f6f1",
  text_secondary: "#b7bcb2",
  card: "#1f2223",
  card_light: "#1f2223",
  button: "#f2c94c",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#1e3a2f",
  bgLight: "#26473a",
  primary: "#ffb4c6",
  secondary: "#8fd0ff",
  text_primary: "#f7f7f0",
  text_secondary: "#c3d3c6",
  card: "#254639",
  card_light: "#254639",
  button: "#ffb4c6",
  white: "#FFFFFF",
  black: "#000000",
};
